import { message } from "antd";
import { getAbsoluteUrl, regexp } from "utils/method";
import { useRouter } from "next/router";
import { useRef, useState } from "react";
import { Hooks } from "@xt/xtbase";
const { useIntl, FormattedMessage } = Hooks;

import Geetest from "components/Geetest";
import FormItem from "components/App/FormItem";
import ButtonBig from "components/Antd/Button/big";
import FormItemInput from "components/App/FormItem/Input";
import sessionStorage from "utils/sessionStorage";
import { get_faCheckToken } from "api/uaapi/user";

import { get_getFaCheckItem } from "api/uaapi/user";
import { put_faLoginPwdBeforeCheck } from "api/uaapi/account";
import axios from "../../../../utils/axios";

export default function StepOne() {
  const intl = useIntl();
  const router = useRouter();
  const geetestRef = useRef();
  const [errMsg, setErrMsg] = useState("");
  const [emailphoneNum, setEmailphoneNum] = useState("");
  const [loading, setLoading] = useState(false);

  const handleClick = () => {
    // 测试要求去掉该正则验证，已经产品确认 2022/7/4，留证
    // if (!regexp("email", emailphoneNum) && !regexp("phone", emailphoneNum)) {
    //   setErrMsg(intl.formatMessage({id: "resetPwd.emailPhoneVerifyTip"}));
    //   return;
    // }

    if (!emailphoneNum) {
      setErrMsg(intl.formatMessage({ id: "resetPwd.emailPhoneTip" }));
      return;
    }
    geetestRef.current.verify();
  };

  const handleNumInput = (val) => {
    setEmailphoneNum(val);
    setErrMsg("");
  };

  const handleGeetestSuccess = async (validateStr) => {
    setLoading(true);

    /*
    const beforeCheckRet = await axios.asyncAwait(put_faLoginPwdBeforeCheck, {
      data: {
        accountLevel: 1,
        puzzleValidateString: validateStr,
        userName: emailphoneNum
      },
      errorPop: true,
    });
    setLoading(false);
    if (beforeCheckRet.err) return;
    if (!beforeCheckRet.data.validNumber) {
      sessionStorage.set("faId", beforeCheckRet.data.faId);
      const query = { ...router.query, step: 3 };
      if (typeof location !== "undefined")
        location.href = getAbsoluteUrl({
          pathname: "/reset-password",
          locale: router.locale,
          query
        });
      else
        router.push({
          path: "./reset-password",
          query
        });
    } else {
      sessionStorage.set("2fa_new", beforeCheckRet.data);
      sessionStorage.set("puzzleValidateString", validateStr);

      const query = { ...router.query, step: 2 };
      if (typeof location !== "undefined")
        location.href = getAbsoluteUrl({
          pathname: "/reset-password",
          locale: router.locale,
          query
        });
      else
        router.push({
          path: "./reset-password",
          query
        });
    }
     */

    get_getFaCheckItem({
      params: {
        faBizType: 13,
        puzzleValidateString: validateStr,
        userName: emailphoneNum
      },
      isReturnResponse: true
    })
      .then((res) => {
        const { code, msg } = res.data;
        if (code != 200) {
          message.error(msg);
          return;
        }
        sessionStorage.set("puzzleValidateString", validateStr);

        const checkRes = res.data.data;
        const { faItems } = checkRes;

        if (Array.isArray(faItems) && faItems.length > 0) {
          sessionStorage.set("2fa", checkRes);
          const query = { ...router.query, step: 2 };
          if (typeof location !== "undefined")
            location.href = getAbsoluteUrl({
              pathname: "/reset-password",
              locale: router.locale,
              query
            });
          else
            router.push({
              path: "./reset-password",
              query
            });
        } else {
          get_faCheckToken({
            params: { faCheckId: checkRes.faResultId, faBizType: 13 }
          }).then((res) => {
            sessionStorage.set("faResultId", res.faResultId);
            const query = { ...router.query, step: 3 };
            if (typeof location !== "undefined")
              location.href = getAbsoluteUrl({
                pathname: "/reset-password",
                locale: router.locale,
                query
              });
            else
              router.push({
                path: "./reset-password",
                query
              });
          });
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className={"stepForm"}>
      <FormItem title={<FormattedMessage id="resetPwd.emailPhone" />} errMsg={errMsg}>
        <FormItemInput
          autoFocus={true}
          isErr={!!errMsg}
          value={emailphoneNum}
          onInput={handleNumInput}
          // placeholder={intl.formatMessage({id: "resetPwd.emailPhone"})}
        />
      </FormItem>
      <Geetest ref={geetestRef} onSuccess={handleGeetestSuccess} />
      <ButtonBig className={"bigBtn"} onClick={handleClick} loading={loading}>
        <FormattedMessage id="resetPwd.next" />
      </ButtonBig>
    </div>
  );
}
